/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/**
 * Replaces all occurrences of the first word outside quotes in a query with a specified field.
 * @param {string} query - The input query to modify.
 * @param {string} field - The field to replace the first word with.
 * @returns {string} - The modified query with the first word replaced by the specified field.
 */

const replaceField = (query, field = 'label') => {
  const words = query.split(/\s+/);
  const firstWord = words[0];
  let withinQuotes = false;
  // Replace all occurrences of the first word (outside quotes) with "label"
  for (let i = 0; i < words.length; i += 1) {
    const currentWord = words[i];
    if (currentWord.startsWith('"')) {
      withinQuotes = true;
    }
    if (currentWord.endsWith('"')) {
      withinQuotes = false;
    }
    if (!withinQuotes && currentWord === firstWord) {
      words[i] = field;
    }
  }
  const modifiedQuery = words.join(' ');
  //
  return modifiedQuery;
};
//
export default replaceField;
